module.exports = __webpack_public_path__ + "img/go1.393a3dc4.png";